import api from '@/common/api/commonApi'
import userApi from '@/module/systemManagement/api/user'
import {
  validUsername,
  validNumber,
  validEmail,
  validPhone,
  validNickname,
  validID,
  validNumber2,
  validRate,
  validDomain
} from '@/common/validUtil'

export default {
  // 校验手机号码
  checkPhone(rule, value, callback) {
    if (!value) {
      callback()
    } else if (!validPhone(value)) {
      callback(new Error('请输入合法的手机号'))
    } else {
      callback()
    }
  },
  // 校验手机号是否已注册
  checkPhoneRegister(rule, value, callback) {
    if(value) {
      api.getUserByUser({mobile: value} ).then(res => {
        if (res.data) {
          callback(new Error('手机号已注册'))
        } else {
          callback()
        }
      })
    } else {
      callback()
    }
  },
  // 根据用户名或者手机号校验用户是否已经注册
  checkUserRegister(rule, value, callback) {
    if(value) {
      userApi.findByUsernameOrMobile(value ).then(res => {
        if (res.data) {
          callback(new Error('已被占用'))
        } else {
          callback()
        }
      })
    } else {
      callback()
    }
  },
  // 校验用户名是否重复，用户名需平台唯一
  checkNameRegister(rule, value, callback) {
    if (value) {
      console.log(value)
      api.getUserByUser({"username": value}).then(res => {
        if (res.data) {
          callback(new Error('用户名已被占用'))
        } else {
          callback()
        }
      })
    } else {
      callback()
    }
  },
  // 校验数字，最多6位小数
  checkNum(rule, value, callback) {
    if (!value) {
      return callback()
    } else if (!validNumber(value)) {
      return callback(new Error('请填写数字,最多6位小数'))
    } else {
      callback()
    }
  },
  checkNum2(rule, value, callback) {
    if (!value) {
      callback()
    } else if (!validNumber2(value, 12)) {
      callback('请输入整数部分小于12位，小数部分小于6位的数字')
    } else {
      callback()
    }
  },
  checkRate(rule, value, callback) {
    if (!value) {
      callback()
    } else if (!validRate(value)) {
      callback('请输入0~1，且小数位数小于2位的小数')
    } else {
      callback()
    }
  },
  checkEmail(rule, value, callback) {
    if (!value) {
      callback()
    } else if (!validEmail(value)) {
      callback(new Error('请输入正确的邮箱地址'))
    } else {
      callback()
    }
  },
  checkUsername(rule, value, callback) {
    if (!value) {
      callback()
    } else if (!validUsername(value)) {
      callback(new Error('只能包含数字、字母、下划线及.-()<>'))
    } else {
      callback()
    }
  },
  checkNickname(rule, value, callback) {
    if (!value) {
      callback()
    } else if (!validNickname(value)) {
      callback(new Error('只能包含数字、字母、下划线、空格、中文及.-()<>'))
    } else {
      callback()
    }
  },
  checkID(rule, value, callback) {
    if (!value) {
      callback()
    } else if (!validID(value)) {
      callback(new Error('只能包含数字、字母'))
    } else {
      callback()
    }
  },
  checkDomain(rule, value, callback) {
    if (!value) {
      callback()
    } else if (!validDomain(value)) {
      callback(new Error('请输入合法的域名'))
    } else {
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/module/memberCenter/common/rules.js